import React, { useState, useEffect } from "react";
import { axiosInstance } from "../axiosInstance";
import { Instagram } from "lucide-react";

const InstagramFeed = () => {
  const [instagramMediaItems, setInstagramMediaItems] = useState(null);

  const getInstagramPosts = () => {
    return axiosInstance.get(`/social-media-feeds?platform=insta&limit=6`);
  };

  useEffect(() => {
    const fetchInstagramPosts = async () => {
      try {
        const response = await getInstagramPosts();
        setInstagramMediaItems(response.data);
      } catch (error) {
        console.error("Error fetching instagram posts:", error);
      }
    };
    fetchInstagramPosts();
  }, []);

  return (
    <>
      <div className="container py-5">
        <div className="text-center mb-4">
          <h1
            className="display-5 text-muted"
            style={{
              //   fontFamily: "'Brush Script MT', cursive",
              letterSpacing: "2px",
              //   opacity: 0.3,
            }}
          >
            Check Out Our
          </h1>
          <h1
            className="fw-bold text-muted"
            style={{
              fontFamily: "'Brush Script MT', cursive",
              marginTop: "clamp(-20px, -8vw, -40px)",
              letterSpacing: "3px",
              fontSize: "clamp(48px, 18vw, 150px)",
              opacity: 0.2,
            }}
          >
            Instagram
          </h1>
        </div>

        {instagramMediaItems && (
          <div className="container">
            <div className="row">
              {instagramMediaItems.data.map((item, index) => {
                if (item.media_type === "VIDEO") {
                  return (
                    <>
                      <div className="col-md-4 my-2 col-12">
                        <video
                          style={{ objectFit: "fill" }}
                          className="border shadow rounded-3"
                          height="400px"
                          width="100%"
                          poster={item.thumbnail_url}
                          controls
                          playsInline
                        >
                          <source src={item.media_url}></source>
                        </video>
                      </div>
                    </>
                  );
                } else if (
                  item.media_type === "IMAGE" ||
                  item.media_type === "CAROUSEL_ALBUM"
                ) {
                  return (
                    <>
                      <div className="col-md-4 my-2 col-12">
                        <img
                          className="border shadow rounded-3"
                          style={{ objectFit: "fill" }}
                          src={item.media_url}
                          alt={item.caption}
                          height="400px"
                          width="100%"
                        ></img>
                      </div>
                    </>
                  );
                }
                return null;
              })}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default InstagramFeed;
